// removed by extract-text-webpack-plugin
module.exports = {"vpQuestionContainer":"vpQuestionContainer___39CAX","vpQuestionPanel":"vpQuestionPanel___3gYdL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/CampaignQuestionContainer.module.less
// module id = 2562
// module chunks = 29